import React, { useState, useRef } from 'react';
import qs from 'qs';

export const SearchContext = React.createContext();

export const SearchProvider = ({ children }) => {
  const queryValues = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  const [carName, setCarName] = useState(queryValues.carName || '');
  const [carId, setCarId] = useState(queryValues.carId || null);
  const [partName, setPartName] = useState(queryValues.partName || '');
  const [partId, setPartId] = useState(queryValues.partId || null);
  const [manuName, setManuName] = useState(queryValues.manuName || '');
  const [manuId, setManuId] = useState(queryValues.manuId || null);
  const [modelName, setModelName] = useState(queryValues.modelName || '');
  const [modelId, setModelId] = useState(queryValues.modelId || queryValues.modId || null);
  const [carTypeName, setCarTypeName] = useState(queryValues.carTypeName || '');
  const [searchCarQuery, setSearchCarQuery] = useState(null);
  const [vinNumber, setVinNumber] = useState(queryValues.vinNumber || '');
  const [vinVehicle, setVinVehicle] = useState(queryValues.vinVehicle || '');
  const [carPlate, setCarPlate] = useState(queryValues.carPlate || '');
  const [reference, setReference] = useState(queryValues.reference || '');
  const [kbaNumber, setKbaNumber] = useState(queryValues.kbaNumber || '');
  const [vehicleType, setVehicleType] = useState(
    queryValues.vehicleType || 'P'
  );
  const [manuCar, setManuCar] = useState(null);
  const [manuTruck, setManuTruck] = useState(null);
  const [isNoCarPlateResults, setIsNoCarPlateResults] = useState(null);

  let manuFieldRef = useRef();

  // @todo: move to a SearchFormContext code below
  const [isEditedManuField, setIsEditedManuField] = useState(false);
  const [isEditedCarField, setIsEditedCarField] = useState(false);
  const [isEditedModelField, setIsEditedModelField] = useState(false);
  const [isEditedVinVehicleField, setIsEditedVinVehicleField] = useState(false);
  const [isEditedPartField, setIsEditedPartField] = useState(false);
  const [isErrorCar, setIsErrorCar] = useState(false);
  const [isErrorPart, setIsErrorPart] = useState(false);
  const [isErrorManu, setIsErrorManu] = useState(false);
  const [isErrorModel, setIsErrorModel] = useState(false);
  const [isErrorVinVehicle, setIsErrorVinVehicle] = useState(false);
  const [isSelectedCar, setIsSelectedCar] = useState(false);
  const [isSelectedManu, setIsSelectedManu] = useState(false);
  const [isSelectedModel, setIsSelectedModel] = useState(false);
  const [isSelectedVin, setIsSelectedVin] = useState(false);
  const [isSelectedVinVehicle, setIsSelectedVinVehicle] = useState(false);
  const [isSelectedPart, setIsSelectedPart] = useState(false);
  const [isSelectedCarPlate, setIsSelectedCarPlate] = useState(false);
  const [isSelectedKba, setIsSelectedKba] = useState(false);
  const [isCarTooltip, setIsCarTooltip] = useState(false);
  const [isManuTooltip, setIsManuTooltip] = useState(false);
  const [isModelTooltip, setIsModelTooltip] = useState(false);
  const [isVinVehicleTooltip, setIsVinVehicleTooltip] = useState(false);
  const [isPartTooltip, setIsPartTooltip] = useState(false);

  return (
    <SearchContext.Provider
      value={{
        carName,
        setCarName,
        carId,
        setCarId,
        partName,
        setPartName,
        partId,
        setPartId,
        manuName,
        setManuName,
        manuId,
        manuFieldRef,
        setManuId,
        modelName,
        setModelName,
        modelId,
        setModelId,
        carTypeName,
        setCarTypeName,
        searchCarQuery,
        setSearchCarQuery,
        vinNumber,
        setVinNumber,
        vinVehicle,
        setVinVehicle,
        reference,
        setReference,
        vehicleType,
        setVehicleType,
        manuCar,
        setManuCar,
        manuTruck,
        setManuTruck,
        carPlate,
        setCarPlate,
        kbaNumber,
        setKbaNumber,
        isNoCarPlateResults,
        setIsNoCarPlateResults,

        // @todo: move to a SearchFormContext code below
        isEditedManuField,
        setIsEditedManuField,
        isEditedCarField,
        setIsEditedCarField,
        isEditedModelField,
        setIsEditedModelField,
        isEditedPartField,
        setIsEditedPartField,
        isEditedVinVehicleField,
        setIsEditedVinVehicleField,
        isErrorCar,
        setIsErrorCar,
        isErrorPart,
        setIsErrorPart,
        isErrorManu,
        setIsErrorManu,
        isErrorVinVehicle,
        setIsErrorVinVehicle,
        isErrorModel,
        setIsErrorModel,
        isSelectedCar,
        setIsSelectedCar,
        isSelectedManu,
        setIsSelectedManu,
        isSelectedModel,
        setIsSelectedModel,
        isSelectedVin,
        setIsSelectedVin,
        isSelectedVinVehicle,
        setIsSelectedVinVehicle,
        isSelectedPart,
        setIsSelectedPart,
        isSelectedCarPlate,
        setIsSelectedCarPlate,
        isCarTooltip,
        setIsCarTooltip,
        isSelectedKba,
        setIsSelectedKba,
        isManuTooltip,
        setIsManuTooltip,
        isModelTooltip,
        setIsModelTooltip,
        isPartTooltip,
        setIsPartTooltip,
        isVinVehicleTooltip,
        setIsVinVehicleTooltip,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/context/SearchContext.js